import { render, staticRenderFns } from "./YearQuiz.vue?vue&type=template&id=6029537b&scoped=true&lang=pug&"
import script from "./YearQuiz.vue?vue&type=script&lang=js&"
export * from "./YearQuiz.vue?vue&type=script&lang=js&"
import style0 from "./YearQuiz.vue?vue&type=style&index=0&id=6029537b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029537b",
  null
  
)

component.options.__file = "YearQuiz.vue"
export default component.exports